import { SchedulesListDataType } from "../../../../../models/list"
import { exportExcelFRM304 } from "./excel"

export const exportFRM304 = (data: SchedulesListDataType[]) => {
  exportExcelFRM304(data)
}
